import { render, staticRenderFns } from "./UpdateNotes.vue?vue&type=template&id=392f7246&scoped=true&"
import script from "./UpdateNotes.vue?vue&type=script&lang=js&"
export * from "./UpdateNotes.vue?vue&type=script&lang=js&"
import style0 from "./UpdateNotes.vue?vue&type=style&index=0&id=392f7246&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392f7246",
  null
  
)

export default component.exports